import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const GetRostersTemplate = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `shift/template`);
};
export const GetRostersTemplateDetail = (id: any) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `shift/template-detail?where=` + id
  );
};

export const AddRosterTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift/template/add`,
    obj,
    { headers }
  );
};
export const deleteTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift/template/delete`,
    obj,
    {
      headers,
    }
  );
};
export const editTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift/template/update`,
    obj,
    { headers }
  );
};
